import React from "react";
import ButtonPrimary from "../ButtonPrimary";
import Link from "../Link";
import { FiX } from "react-icons/fi";
import { Container, Modal, Header, Content, Footer } from "./styles"

const ModalLayout = ({ showModal, title, handleCloseModal, children, buttonLeft, buttonRight, removePaddingContent }) => {
    return (
        <>
            {showModal && (
                <Container>
                    <Modal>
                        <Header>
                            <button onClick={handleCloseModal}>
                                <FiX size={24} style={{ color: "var(--neutral-900)" }} />
                            </button>
                            <h1>{title}</h1>
                        </Header>
                        <Content removePadding={removePaddingContent}>
                            {children}
                        </Content>
                        {buttonLeft && buttonRight && (
                            <Footer>
                                <ButtonPrimary text={buttonLeft.text} onClick={buttonLeft.action} disabled={buttonLeft.disabled} />
                                <Link text={buttonRight.text} disabled={buttonRight.disabled} action={buttonRight.action} />
                            </Footer>
                        )}
                    </Modal>
                </Container>
            )}
        </>

    )
}

export default ModalLayout;